import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/UI/table';
import { ArrowRightIcon } from '@heroicons/react/20/solid';
import clsx from 'clsx';

import srcHeroPattern from './images/hero-pattern.svg';

const nflSeasons = [
  {
    season: '2024',
    win: 43,
    loss: 34,
    push: 2,
    units: 5.45,
  },
  {
    season: '2023',
    win: 54,
    loss: 32,
    push: 3,
    units: 18.55,
  },
  {
    season: '2022',
    win: 30,
    loss: 24,
    push: 1,
    units: 3.45,
  },
  {
    season: '2021',
    win: 30,
    loss: 24,
    push: 0,
    units: 4.5,
  },
  {
    season: '2020',
    win: 20,
    loss: 10,
    push: 1,
    units: 8.95,
  },
  {
    season: '2019',
    win: 28,
    loss: 19,
    push: 0,
    units: 6.9,
  },
  {
    season: '2018',
    win: 32,
    loss: 26,
    push: 2,
    units: 3.55,
  },
  {
    season: '2017',
    win: 14,
    loss: 7,
    push: 0,
    units: 6.05,
  },
];

const nflBreakdowns = [
  {
    season: 'All time',
    win: 251,
    loss: 176,
    push: 9,
    units: 57.4,
  },
  {
    season: 'Preseason',
    win: 125,
    loss: 85,
    push: 1,
    units: 31.8,
  },
  {
    season: 'Regular',
    win: 126,
    loss: 91,
    push: 9,
    units: 25.6,
  },
];

function toFixed(num?: number) {
  if (typeof num !== 'number') {
    return num;
  }

  return (num || 0).toFixed(2);
}

// const backupStats = {
//   stats: {
//     '1': {
//       cumulative: {
//         win: 1094,
//         loss: 854,
//         pending: 14,
//         push: 18,
//         canceled: 6,
//         noAction: 0,
//         risk: 1954.5,
//         units: 173.4,
//         total: 1986,
//       },
//       seasons: {
//         '1': {
//           win: 36,
//           loss: 29,
//           pending: 0,
//           push: 0,
//           canceled: 0,
//           noAction: 0,
//           risk: 172,
//           units: 12.4,
//           total: 130,
//         },
//         '2': {
//           win: 33,
//           loss: 35,
//           pending: 0,
//           push: 0,
//           canceled: 0,
//           noAction: 0,
//           risk: 180,
//           units: 3.6,
//           total: 136,
//         },
//         '3': {
//           win: 24,
//           loss: 14,
//           pending: 0,
//           push: 0,
//           canceled: 0,
//           noAction: 0,
//           risk: 102,
//           units: 13.8,
//           total: 76,
//         },
//         '4': {
//           win: 19,
//           loss: 17,
//           pending: 0,
//           push: 0,
//           canceled: 0,
//           noAction: 0,
//           risk: 92,
//           units: 3.8,
//           total: 72,
//         },
//         '5': {
//           win: 18,
//           loss: 13,
//           pending: 0,
//           push: 0,
//           canceled: 0,
//           noAction: 0,
//           risk: 70,
//           units: 11.2,
//           total: 62,
//         },
//         '6': {
//           win: 17,
//           loss: 23,
//           pending: 0,
//           push: 0,
//           canceled: 1,
//           noAction: 0,
//           risk: 147,
//           units: -26.099999999999998,
//           total: 123,
//         },
//         '7': {
//           win: 73,
//           loss: 55,
//           pending: 0,
//           push: 2,
//           canceled: 0,
//           noAction: 0,
//           risk: 276,
//           units: 14.850000000000001,
//           total: 390,
//         },
//         '8': {
//           win: 58,
//           loss: 54,
//           pending: 0,
//           push: 0,
//           canceled: 0,
//           noAction: 0,
//           risk: 148,
//           units: 3.1,
//           total: 224,
//         },
//         '9': {
//           win: 40,
//           loss: 39,
//           pending: 0,
//           push: 0,
//           canceled: 0,
//           noAction: 0,
//           risk: 104,
//           units: 1.1,
//           total: 158,
//         },
//         '10': {
//           win: 27,
//           loss: 21,
//           pending: 0,
//           push: 0,
//           canceled: 0,
//           noAction: 0,
//           risk: 64,
//           units: 1,
//           total: 96,
//         },
//         '11': {
//           win: 23,
//           loss: 21,
//           pending: 0,
//           push: 1,
//           canceled: 0,
//           noAction: 0,
//           risk: 100.5,
//           units: 7.6499999999999995,
//           total: 135,
//         },
//         '12': {
//           win: 23,
//           loss: 19,
//           pending: 0,
//           push: 0,
//           canceled: 0,
//           noAction: 0,
//           risk: 94,
//           units: 10,
//           total: 84,
//         },
//         '13': {
//           win: 40,
//           loss: 19,
//           pending: 0,
//           push: 0,
//           canceled: 0,
//           noAction: 0,
//           risk: 124,
//           units: 44.2,
//           total: 118,
//         },
//         '14': {
//           win: 35,
//           loss: 24,
//           pending: 0,
//           push: 1,
//           canceled: 0,
//           noAction: 0,
//           risk: 189,
//           units: 31.650000000000002,
//           total: 180,
//         },
//         '15': {
//           win: 48,
//           loss: 27,
//           pending: 0,
//           push: 0,
//           canceled: 1,
//           noAction: 0,
//           risk: 231,
//           units: 57.900000000000006,
//           total: 228,
//         },
//         '16': {
//           win: 37,
//           loss: 33,
//           pending: 0,
//           push: 0,
//           canceled: 0,
//           noAction: 0,
//           risk: 141,
//           units: 0.3,
//           total: 140,
//         },
//         '17': {
//           win: 49,
//           loss: 40,
//           pending: 0,
//           push: 0,
//           canceled: 0,
//           noAction: 0,
//           risk: 180,
//           units: 12,
//           total: 178,
//         },
//         '18': {
//           win: 69,
//           loss: 55,
//           pending: 0,
//           push: 1,
//           canceled: 2,
//           noAction: 0,
//           risk: 528,
//           units: 41.2,
//           total: 508,
//         },
//         '19': {
//           win: 70,
//           loss: 46,
//           pending: 0,
//           push: 1,
//           canceled: 0,
//           noAction: 0,
//           risk: 357,
//           units: 57.75,
//           total: 351,
//         },
//         '20': {
//           win: 54,
//           loss: 45,
//           pending: 0,
//           push: 1,
//           canceled: 1,
//           noAction: 0,
//           risk: 406,
//           units: 18.2,
//           total: 404,
//         },
//         '21': {
//           win: 68,
//           loss: 68,
//           pending: 0,
//           push: 2,
//           canceled: 0,
//           noAction: 0,
//           risk: 414,
//           units: -21.450000000000003,
//           total: 414,
//         },
//         '22': {
//           win: 15,
//           loss: 8,
//           pending: 0,
//           push: 2,
//           canceled: 0,
//           noAction: 0,
//           risk: 75,
//           units: 17.85,
//           total: 75,
//         },
//         '23': {
//           win: 26,
//           loss: 23,
//           pending: 0,
//           push: 0,
//           canceled: 0,
//           noAction: 0,
//           risk: 98,
//           units: 1.1,
//           total: 98,
//         },
//         '24': {
//           win: 18,
//           loss: 20,
//           pending: 0,
//           push: 1,
//           canceled: 0,
//           noAction: 0,
//           risk: 117,
//           units: -12.450000000000001,
//           total: 117,
//         },
//         '25': {
//           win: 34,
//           loss: 19,
//           pending: 0,
//           push: 1,
//           canceled: 1,
//           noAction: 0,
//           risk: 220,
//           units: 52.4,
//           total: 220,
//         },
//         '26': {
//           win: 50,
//           loss: 28,
//           pending: 0,
//           push: 2,
//           canceled: 0,
//           noAction: 0,
//           risk: 240,
//           units: 57.449999999999996,
//           total: 240,
//         },
//         '27': {
//           win: 77,
//           loss: 53,
//           pending: 0,
//           push: 3,
//           canceled: 0,
//           noAction: 0,
//           risk: 399,
//           units: 55.650000000000006,
//           total: 399,
//         },
//         '64': {
//           win: 13,
//           loss: 6,
//           pending: 14,
//           push: 0,
//           canceled: 0,
//           noAction: 0,
//           risk: 99,
//           units: 19.200000000000003,
//           total: 99,
//         },
//       },
//       firstSeasonId: 1,
//       lastSeasonId: 64,
//       firstSeasonDate: 867740400000,
//       lastSeasonDate: 1719817200000,
//       last4Ids: [25, 26, 27, 64],
//       last4: [
//         {
//           win: 34,
//           loss: 19,
//           pending: 0,
//           push: 1,
//           canceled: 1,
//           noAction: 0,
//           risk: 55,
//           units: 13.100000000000001,
//           total: 55,
//         },
//         {
//           win: 50,
//           loss: 28,
//           pending: 0,
//           push: 2,
//           canceled: 0,
//           noAction: 0,
//           risk: 80,
//           units: 19.15,
//           total: 80,
//         },
//         {
//           win: 77,
//           loss: 53,
//           pending: 0,
//           push: 3,
//           canceled: 0,
//           noAction: 0,
//           risk: 133,
//           units: 18.549999999999997,
//           total: 133,
//         },
//         {
//           win: 13,
//           loss: 6,
//           pending: 14,
//           push: 0,
//           canceled: 0,
//           noAction: 0,
//           risk: 33,
//           units: 6.4,
//           total: 33,
//         },
//       ],
//       seasonsMeta: {
//         '1': {
//           id: 1,
//           name: '1997',
//           type: null,
//           stats: {
//             win: 36,
//             loss: 29,
//             push: 0,
//             unit: 6.2,
//             pending: 0,
//             canceled: 0,
//             noAction: 0,
//             uncharged: 65,
//           },
//           hidden: false,
//           endDate: '1998-07-01T06:59:59+00:00',
//           sportId: 1,
//           createdAt: '2024-01-22T23:15:47.135288+00:00',
//           startDate: '1997-07-01T07:00:00+00:00',
//           updatedAt: null,
//         },
//         '2': {
//           id: 2,
//           name: '1998',
//           type: null,
//           stats: {
//             win: 33,
//             loss: 35,
//             push: 0,
//             unit: 1.8,
//             pending: 0,
//             canceled: 0,
//             noAction: 0,
//             uncharged: 68,
//           },
//           hidden: false,
//           endDate: '1999-07-01T06:59:59+00:00',
//           sportId: 1,
//           createdAt: '2024-01-22T23:15:47.135288+00:00',
//           startDate: '1998-07-01T07:00:00+00:00',
//           updatedAt: null,
//         },
//         '3': {
//           id: 3,
//           name: '1999',
//           type: null,
//           stats: {
//             win: 92,
//             loss: 76,
//             push: 2,
//             unit: 12.4,
//             pending: 0,
//             canceled: 0,
//             noAction: 0,
//             uncharged: 170,
//           },
//           hidden: false,
//           endDate: '2000-07-01T06:59:59+00:00',
//           sportId: 1,
//           createdAt: '2024-01-22T23:15:47.135288+00:00',
//           startDate: '1999-07-01T07:00:00+00:00',
//           updatedAt: null,
//         },
//         '4': {
//           id: 4,
//           name: '2000',
//           type: null,
//           stats: {
//             win: 19,
//             loss: 17,
//             push: 0,
//             unit: 1.9,
//             pending: 0,
//             canceled: 0,
//             noAction: 0,
//             uncharged: 36,
//           },
//           hidden: false,
//           endDate: '2001-07-01T06:59:59+00:00',
//           sportId: 1,
//           createdAt: '2024-01-22T23:15:47.135288+00:00',
//           startDate: '2000-07-01T07:00:00+00:00',
//           updatedAt: null,
//         },
//         '5': {
//           id: 5,
//           name: '2001',
//           type: null,
//           stats: {
//             win: 18,
//             loss: 13,
//             push: 0,
//             unit: 5.6,
//             pending: 0,
//             canceled: 0,
//             noAction: 0,
//             uncharged: 31,
//           },
//           hidden: false,
//           endDate: '2002-07-01T06:59:59+00:00',
//           sportId: 1,
//           createdAt: '2024-01-22T23:15:47.135288+00:00',
//           startDate: '2001-07-01T07:00:00+00:00',
//           updatedAt: null,
//         },
//         '6': {
//           id: 6,
//           name: '2002',
//           type: null,
//           stats: {
//             win: 17,
//             loss: 23,
//             push: 0,
//             unit: -8.7,
//             pending: 0,
//             canceled: 1,
//             noAction: 0,
//             uncharged: 40,
//           },
//           hidden: false,
//           endDate: '2003-07-01T06:59:59+00:00',
//           sportId: 1,
//           createdAt: '2024-01-22T23:15:47.135288+00:00',
//           startDate: '2002-07-01T07:00:00+00:00',
//           updatedAt: null,
//         },
//         '7': {
//           id: 7,
//           name: '2003',
//           type: null,
//           stats: {
//             win: 73,
//             loss: 55,
//             push: 2,
//             unit: 4.95,
//             pending: 0,
//             canceled: 0,
//             noAction: 0,
//             uncharged: 130,
//           },
//           hidden: false,
//           endDate: '2004-07-01T06:59:59+00:00',
//           sportId: 1,
//           createdAt: '2024-01-22T23:15:47.135288+00:00',
//           startDate: '2003-07-01T07:00:00+00:00',
//           updatedAt: null,
//         },
//         '8': {
//           id: 8,
//           name: '2004',
//           type: null,
//           stats: {
//             win: 58,
//             loss: 54,
//             push: 0,
//             unit: 1.55,
//             pending: 0,
//             canceled: 0,
//             noAction: 0,
//             uncharged: 112,
//           },
//           hidden: false,
//           endDate: '2005-07-01T06:59:59+00:00',
//           sportId: 1,
//           createdAt: '2024-01-22T23:15:47.135288+00:00',
//           startDate: '2004-07-01T07:00:00+00:00',
//           updatedAt: null,
//         },
//         '9': {
//           id: 9,
//           name: '2005',
//           type: null,
//           stats: {
//             win: 40,
//             loss: 39,
//             push: 0,
//             unit: 0.55,
//             pending: 0,
//             canceled: 0,
//             noAction: 0,
//             uncharged: 79,
//           },
//           hidden: false,
//           endDate: '2006-07-01T06:59:59+00:00',
//           sportId: 1,
//           createdAt: '2024-01-22T23:15:47.135288+00:00',
//           startDate: '2005-07-01T07:00:00+00:00',
//           updatedAt: null,
//         },
//         '10': {
//           id: 10,
//           name: '2006',
//           type: null,
//           stats: {
//             win: 27,
//             loss: 21,
//             push: 0,
//             unit: 0.5,
//             pending: 0,
//             canceled: 0,
//             noAction: 0,
//             uncharged: 48,
//           },
//           hidden: false,
//           endDate: '2007-07-01T06:59:59+00:00',
//           sportId: 1,
//           createdAt: '2024-01-22T23:15:47.135288+00:00',
//           startDate: '2006-07-01T07:00:00+00:00',
//           updatedAt: null,
//         },
//         '11': {
//           id: 11,
//           name: '2007',
//           type: null,
//           stats: {
//             win: 23,
//             loss: 21,
//             push: 1,
//             unit: 2.55,
//             pending: 0,
//             canceled: 0,
//             noAction: 0,
//             uncharged: 45,
//           },
//           hidden: false,
//           endDate: '2008-07-01T06:59:59+00:00',
//           sportId: 1,
//           createdAt: '2024-01-22T23:15:47.135288+00:00',
//           startDate: '2007-07-01T07:00:00+00:00',
//           updatedAt: null,
//         },
//         '12': {
//           id: 12,
//           name: '2008',
//           type: null,
//           stats: {
//             win: 23,
//             loss: 19,
//             push: 0,
//             unit: 5,
//             pending: 0,
//             canceled: 0,
//             noAction: 0,
//             uncharged: 42,
//           },
//           hidden: false,
//           endDate: '2009-07-01T06:59:59+00:00',
//           sportId: 1,
//           createdAt: '2024-01-22T23:15:47.135288+00:00',
//           startDate: '2008-07-01T07:00:00+00:00',
//           updatedAt: null,
//         },
//         '13': {
//           id: 13,
//           name: '2009',
//           type: null,
//           stats: {
//             win: 40,
//             loss: 19,
//             push: 0,
//             unit: 22.1,
//             pending: 0,
//             canceled: 0,
//             noAction: 0,
//             uncharged: 59,
//           },
//           hidden: false,
//           endDate: '2010-07-01T06:59:59+00:00',
//           sportId: 1,
//           createdAt: '2024-01-22T23:15:47.135288+00:00',
//           startDate: '2009-07-01T07:00:00+00:00',
//           updatedAt: null,
//         },
//         '14': {
//           id: 14,
//           name: '2010',
//           type: null,
//           stats: {
//             win: 35,
//             loss: 24,
//             push: 1,
//             unit: 10.55,
//             pending: 0,
//             canceled: 0,
//             noAction: 0,
//             uncharged: 60,
//           },
//           hidden: false,
//           endDate: '2011-07-01T06:59:59+00:00',
//           sportId: 1,
//           createdAt: '2024-01-22T23:15:47.135288+00:00',
//           startDate: '2010-07-01T07:00:00+00:00',
//           updatedAt: null,
//         },
//         '15': {
//           id: 15,
//           name: '2011',
//           type: null,
//           stats: {
//             win: 48,
//             loss: 27,
//             push: 0,
//             unit: 19.3,
//             pending: 0,
//             canceled: 1,
//             noAction: 0,
//             uncharged: 76,
//           },
//           hidden: false,
//           endDate: '2012-07-01T06:59:59+00:00',
//           sportId: 1,
//           createdAt: '2024-01-22T23:15:47.135288+00:00',
//           startDate: '2011-07-01T07:00:00+00:00',
//           updatedAt: null,
//         },
//         '16': {
//           id: 16,
//           name: '2012',
//           type: null,
//           stats: {
//             win: 37,
//             loss: 33,
//             push: 0,
//             unit: 0.15,
//             pending: 0,
//             canceled: 0,
//             noAction: 0,
//             uncharged: 70,
//           },
//           hidden: false,
//           endDate: '2013-07-01T06:59:59+00:00',
//           sportId: 1,
//           createdAt: '2024-01-22T23:15:47.135288+00:00',
//           startDate: '2012-07-01T07:00:00+00:00',
//           updatedAt: null,
//         },
//         '17': {
//           id: 17,
//           name: '2013',
//           type: null,
//           stats: {
//             win: 49,
//             loss: 40,
//             push: 0,
//             unit: 6,
//             pending: 0,
//             canceled: 0,
//             noAction: 0,
//             uncharged: 89,
//           },
//           hidden: false,
//           endDate: '2014-07-01T06:59:59+00:00',
//           sportId: 1,
//           createdAt: '2024-01-22T23:15:47.135288+00:00',
//           startDate: '2013-07-01T07:00:00+00:00',
//           updatedAt: null,
//         },
//         '18': {
//           id: 18,
//           name: '2014',
//           type: null,
//           stats: {
//             win: 69,
//             loss: 55,
//             push: 1,
//             unit: 10.3,
//             pending: 0,
//             canceled: 2,
//             noAction: 0,
//             uncharged: 127,
//           },
//           hidden: false,
//           endDate: '2015-07-01T06:59:59+00:00',
//           sportId: 1,
//           createdAt: '2024-01-22T23:15:47.135288+00:00',
//           startDate: '2014-07-01T07:00:00+00:00',
//           updatedAt: null,
//         },
//         '19': {
//           id: 19,
//           name: '2015',
//           type: null,
//           stats: {
//             win: 70,
//             loss: 46,
//             push: 1,
//             unit: 19.25,
//             pending: 0,
//             canceled: 0,
//             noAction: 0,
//             uncharged: 117,
//           },
//           hidden: false,
//           endDate: '2016-07-01T06:59:59+00:00',
//           sportId: 1,
//           createdAt: '2024-01-22T23:15:47.135288+00:00',
//           startDate: '2015-07-01T07:00:00+00:00',
//           updatedAt: null,
//         },
//         '20': {
//           id: 20,
//           name: '2016',
//           type: null,
//           stats: {
//             win: 54,
//             loss: 45,
//             push: 1,
//             unit: 4.55,
//             pending: 0,
//             canceled: 1,
//             noAction: 0,
//             uncharged: 101,
//           },
//           hidden: false,
//           endDate: '2017-07-01T06:59:59+00:00',
//           sportId: 1,
//           createdAt: '2024-01-22T23:15:47.135288+00:00',
//           startDate: '2016-07-01T07:00:00+00:00',
//           updatedAt: null,
//         },
//         '21': {
//           id: 21,
//           name: '2017',
//           type: null,
//           stats: {
//             win: 68,
//             loss: 68,
//             push: 2,
//             unit: -7.15,
//             pending: 0,
//             canceled: 0,
//             noAction: 0,
//             uncharged: 138,
//           },
//           hidden: false,
//           endDate: '2018-07-01T06:59:59+00:00',
//           sportId: 1,
//           createdAt: '2024-01-22T23:15:47.135288+00:00',
//           startDate: '2017-07-01T07:00:00+00:00',
//           updatedAt: null,
//         },
//         '22': {
//           id: 22,
//           name: '2018',
//           type: null,
//           stats: {
//             win: 15,
//             loss: 8,
//             push: 2,
//             unit: 5.95,
//             pending: 0,
//             canceled: 0,
//             noAction: 0,
//             uncharged: 25,
//           },
//           hidden: false,
//           endDate: '2019-07-01T06:59:59+00:00',
//           sportId: 1,
//           createdAt: '2024-01-22T23:15:47.135288+00:00',
//           startDate: '2018-07-01T07:00:00+00:00',
//           updatedAt: null,
//         },
//         '23': {
//           id: 23,
//           name: '2019',
//           type: null,
//           stats: {
//             win: 26,
//             loss: 23,
//             push: 0,
//             unit: 0.55,
//             pending: 0,
//             canceled: 0,
//             noAction: 0,
//             uncharged: 49,
//           },
//           hidden: false,
//           endDate: '2020-07-01T06:59:59+00:00',
//           sportId: 1,
//           createdAt: '2024-01-22T23:15:47.135288+00:00',
//           startDate: '2019-07-01T07:00:00+00:00',
//           updatedAt: null,
//         },
//         '24': {
//           id: 24,
//           name: '2020',
//           type: null,
//           stats: {
//             win: 18,
//             loss: 20,
//             push: 1,
//             unit: -4.15,
//             pending: 0,
//             canceled: 0,
//             noAction: 0,
//             uncharged: 39,
//           },
//           hidden: false,
//           endDate: '2021-07-01T06:59:59+00:00',
//           sportId: 1,
//           createdAt: '2024-01-22T23:15:47.135288+00:00',
//           startDate: '2020-07-01T07:00:00+00:00',
//           updatedAt: null,
//         },
//         '25': {
//           id: 25,
//           name: '2021',
//           type: null,
//           stats: {
//             win: 34,
//             loss: 19,
//             push: 1,
//             unit: 13.1,
//             pending: 0,
//             canceled: 1,
//             noAction: 0,
//             uncharged: 55,
//           },
//           hidden: false,
//           endDate: '2022-07-01T06:59:59+00:00',
//           sportId: 1,
//           createdAt: '2024-01-22T23:15:47.135288+00:00',
//           startDate: '2021-07-01T07:00:00+00:00',
//           updatedAt: null,
//         },
//         '26': {
//           id: 26,
//           name: '2022',
//           type: null,
//           stats: {
//             win: 50,
//             loss: 28,
//             push: 2,
//             unit: 19.15,
//             pending: 0,
//             canceled: 0,
//             noAction: 0,
//             uncharged: 12,
//           },
//           hidden: false,
//           endDate: '2023-07-01T06:59:59+00:00',
//           sportId: 1,
//           createdAt: '2024-01-22T23:15:47.135288+00:00',
//           startDate: '2022-07-01T07:00:00+00:00',
//           updatedAt: null,
//         },
//         '27': {
//           id: 27,
//           name: '2023',
//           type: null,
//           stats: {
//             win: 77,
//             loss: 53,
//             push: 3,
//             unit: 18.55,
//             pending: 0,
//             canceled: 0,
//             noAction: 0,
//             uncharged: 32,
//           },
//           hidden: false,
//           endDate: '2024-07-01T06:59:59+00:00',
//           sportId: 1,
//           createdAt: '2024-01-22T23:15:47.135288+00:00',
//           startDate: '2023-07-01T07:00:00+00:00',
//           updatedAt: null,
//         },
//         '64': {
//           id: 64,
//           name: '2024',
//           type: null,
//           stats: {
//             win: 13,
//             loss: 6,
//             push: 0,
//             unit: 6.4,
//             pending: 6,
//             canceled: 0,
//             noAction: 0,
//             uncharged: 22,
//           },
//           hidden: false,
//           endDate: '2025-01-22T07:59:00+00:00',
//           sportId: 1,
//           createdAt: '2024-08-30T14:57:11.315113+00:00',
//           startDate: '2024-07-01T07:00:00+00:00',
//           updatedAt: null,
//         },
//       },
//       sportMeta: { id: 1, name: 'College football', active: true, shortName: 'CFB' },
//     },
//     '2': {
//       cumulative: {
//         win: 3469,
//         loss: 2835,
//         pending: 0,
//         push: 118,
//         canceled: 5,
//         noAction: 0,
//         risk: 6431.5,
//         units: 361.6500000000001,
//         total: 6427,
//       },
//       seasons: {
//         '28': {
//           win: 59,
//           loss: 50,
//           pending: 0,
//           push: 2,
//           canceled: 0,
//           noAction: 0,
//           risk: 408,
//           units: 5.4,
//           total: 333,
//         },
//         '29': {
//           win: 60,
//           loss: 50,
//           pending: 0,
//           push: 4,
//           canceled: 0,
//           noAction: 0,
//           risk: 393,
//           units: 34.8,
//           total: 342,
//         },
//         '30': {
//           win: 45,
//           loss: 33,
//           pending: 0,
//           push: 0,
//           canceled: 0,
//           noAction: 0,
//           risk: 170,
//           units: 23,
//           total: 156,
//         },
//         '31': {
//           win: 97,
//           loss: 88,
//           pending: 0,
//           push: 5,
//           canceled: 0,
//           noAction: 0,
//           risk: 423,
//           units: 1.6500000000000001,
//           total: 570,
//         },
//         '32': {
//           win: 87,
//           loss: 74,
//           pending: 0,
//           push: 2,
//           canceled: 0,
//           noAction: 0,
//           risk: 406.5,
//           units: 5.1,
//           total: 489,
//         },
//         '33': {
//           win: 76,
//           loss: 64,
//           pending: 0,
//           push: 2,
//           canceled: 0,
//           noAction: 0,
//           risk: 346.5,
//           units: 22.35,
//           total: 426,
//         },
//         '34': {
//           win: 80,
//           loss: 46,
//           pending: 0,
//           push: 2,
//           canceled: 0,
//           noAction: 0,
//           risk: 289.5,
//           units: 62.849999999999994,
//           total: 384,
//         },
//         '35': {
//           win: 160,
//           loss: 121,
//           pending: 0,
//           push: 7,
//           canceled: 0,
//           noAction: 0,
//           risk: 706.5,
//           units: 61.650000000000006,
//           total: 864,
//         },
//         '36': {
//           win: 272,
//           loss: 215,
//           pending: 0,
//           push: 10,
//           canceled: 0,
//           noAction: 0,
//           risk: 1549.5,
//           units: 122.55000000000001,
//           total: 1491,
//         },
//         '37': {
//           win: 265,
//           loss: 188,
//           pending: 0,
//           push: 7,
//           canceled: 0,
//           noAction: 0,
//           risk: 1426.5,
//           units: 183.3,
//           total: 1380,
//         },
//         '38': {
//           win: 232,
//           loss: 220,
//           pending: 0,
//           push: 5,
//           canceled: 0,
//           noAction: 0,
//           risk: 1413,
//           units: -25.799999999999997,
//           total: 1371,
//         },
//         '39': {
//           win: 173,
//           loss: 133,
//           pending: 0,
//           push: 6,
//           canceled: 0,
//           noAction: 0,
//           risk: 955.5,
//           units: 90.15,
//           total: 936,
//         },
//         '40': {
//           win: 101,
//           loss: 55,
//           pending: 0,
//           push: 4,
//           canceled: 0,
//           noAction: 0,
//           risk: 487.5,
//           units: 129,
//           total: 480,
//         },
//         '41': {
//           win: 105,
//           loss: 87,
//           pending: 0,
//           push: 5,
//           canceled: 0,
//           noAction: 0,
//           risk: 609,
//           units: 28.650000000000002,
//           total: 591,
//         },
//         '42': {
//           win: 189,
//           loss: 176,
//           pending: 0,
//           push: 6,
//           canceled: 0,
//           noAction: 0,
//           risk: 1153.5,
//           units: -8.55,
//           total: 1113,
//         },
//         '43': {
//           win: 122,
//           loss: 98,
//           pending: 0,
//           push: 6,
//           canceled: 0,
//           noAction: 0,
//           risk: 687,
//           units: 48,
//           total: 678,
//         },
//         '44': {
//           win: 287,
//           loss: 241,
//           pending: 0,
//           push: 15,
//           canceled: 0,
//           noAction: 0,
//           risk: 1689,
//           units: 55.800000000000004,
//           total: 1629,
//         },
//         '45': {
//           win: 138,
//           loss: 89,
//           pending: 0,
//           push: 3,
//           canceled: 0,
//           noAction: 0,
//           risk: 702,
//           units: 118.35000000000001,
//           total: 690,
//         },
//         '46': {
//           win: 88,
//           loss: 63,
//           pending: 0,
//           push: 2,
//           canceled: 0,
//           noAction: 0,
//           risk: 459,
//           units: 55.5,
//           total: 459,
//         },
//         '47': {
//           win: 35,
//           loss: 39,
//           pending: 0,
//           push: 0,
//           canceled: 0,
//           noAction: 0,
//           risk: 148,
//           units: -16.3,
//           total: 148,
//         },
//         '48': {
//           win: 72,
//           loss: 64,
//           pending: 0,
//           push: 2,
//           canceled: 2,
//           noAction: 0,
//           risk: 564,
//           units: 1.4,
//           total: 560,
//         },
//         '49': {
//           win: 177,
//           loss: 127,
//           pending: 0,
//           push: 2,
//           canceled: 3,
//           noAction: 0,
//           risk: 1248,
//           units: 154.6,
//           total: 1236,
//         },
//         '50': {
//           win: 247,
//           loss: 214,
//           pending: 0,
//           push: 7,
//           canceled: 0,
//           noAction: 0,
//           risk: 1405.5,
//           units: 33,
//           total: 1404,
//         },
//         '51': {
//           win: 234,
//           loss: 238,
//           pending: 0,
//           push: 12,
//           canceled: 0,
//           noAction: 0,
//           risk: 1453.5,
//           units: -82.35,
//           total: 1452,
//         },
//         '65': {
//           win: 68,
//           loss: 62,
//           pending: 0,
//           push: 2,
//           canceled: 0,
//           noAction: 0,
//           risk: 495,
//           units: 16.5,
//           total: 396,
//         },
//       },
//       firstSeasonId: 65,
//       lastSeasonId: 51,
//       firstSeasonDate: 930812400000,
//       lastSeasonDate: 1688194800000,
//       last4Ids: [65, 49, 50, 51],
//       last4: [
//         {
//           win: 0,
//           loss: 0,
//           pending: 0,
//           push: 0,
//           canceled: 0,
//           noAction: 0,
//           risk: 0,
//           units: 0,
//           total: 0,
//         },
//         {
//           win: 177,
//           loss: 127,
//           pending: 0,
//           push: 2,
//           canceled: 3,
//           noAction: 0,
//           risk: 312,
//           units: 38.650000000000006,
//           total: 309,
//         },
//         {
//           win: 247,
//           loss: 214,
//           pending: 0,
//           push: 7,
//           canceled: 0,
//           noAction: 0,
//           risk: 468.5,
//           units: 11,
//           total: 468,
//         },
//         {
//           win: 302,
//           loss: 300,
//           pending: 0,
//           push: 14,
//           canceled: 0,
//           noAction: 0,
//           risk: 649.5,
//           units: -21.94999999999999,
//           total: 616,
//         },
//       ],
//       seasonsMeta: {
//         '28': {
//           id: 28,
//           name: '2000-01',
//           type: null,
//           stats: {
//             win: 59,
//             loss: 50,
//             push: 2,
//             unit: 1.8,
//             pending: 0,
//             canceled: 0,
//             noAction: 0,
//             uncharged: 110,
//           },
//           hidden: false,
//           endDate: '2001-07-01T06:59:59+00:00',
//           sportId: 2,
//           createdAt: '2024-01-22T23:15:47.135288+00:00',
//           startDate: '2000-07-01T07:00:00+00:00',
//           updatedAt: null,
//         },
//         '29': {
//           id: 29,
//           name: '2001-02',
//           type: null,
//           stats: {
//             win: 60,
//             loss: 50,
//             push: 4,
//             unit: 11.6,
//             pending: 0,
//             canceled: 0,
//             noAction: 0,
//             uncharged: 114,
//           },
//           hidden: false,
//           endDate: '2002-07-01T06:59:59+00:00',
//           sportId: 2,
//           createdAt: '2024-01-22T23:15:47.135288+00:00',
//           startDate: '2001-07-01T07:00:00+00:00',
//           updatedAt: null,
//         },
//         '30': {
//           id: 30,
//           name: '2002-03',
//           type: null,
//           stats: {
//             win: 45,
//             loss: 33,
//             push: 0,
//             unit: 11.5,
//             pending: 0,
//             canceled: 0,
//             noAction: 0,
//             uncharged: 78,
//           },
//           hidden: false,
//           endDate: '2003-07-01T06:59:59+00:00',
//           sportId: 2,
//           createdAt: '2024-01-22T23:15:47.135288+00:00',
//           startDate: '2002-07-01T07:00:00+00:00',
//           updatedAt: null,
//         },
//         '31': {
//           id: 31,
//           name: '2003-04',
//           type: null,
//           stats: {
//             win: 97,
//             loss: 88,
//             push: 5,
//             unit: 0.55,
//             pending: 0,
//             canceled: 0,
//             noAction: 0,
//             uncharged: 190,
//           },
//           hidden: false,
//           endDate: '2004-07-01T06:59:59+00:00',
//           sportId: 2,
//           createdAt: '2024-01-22T23:15:47.135288+00:00',
//           startDate: '2003-07-01T07:00:00+00:00',
//           updatedAt: null,
//         },
//         '32': {
//           id: 32,
//           name: '2004-05',
//           type: null,
//           stats: {
//             win: 87,
//             loss: 74,
//             push: 2,
//             unit: 1.7,
//             pending: 0,
//             canceled: 0,
//             noAction: 0,
//             uncharged: 163,
//           },
//           hidden: false,
//           endDate: '2005-07-01T06:59:59+00:00',
//           sportId: 2,
//           createdAt: '2024-01-22T23:15:47.135288+00:00',
//           startDate: '2004-07-01T07:00:00+00:00',
//           updatedAt: null,
//         },
//         '33': {
//           id: 33,
//           name: '2005-06',
//           type: null,
//           stats: {
//             win: 76,
//             loss: 64,
//             push: 2,
//             unit: 7.45,
//             pending: 0,
//             canceled: 0,
//             noAction: 0,
//             uncharged: 142,
//           },
//           hidden: false,
//           endDate: '2006-07-01T06:59:59+00:00',
//           sportId: 2,
//           createdAt: '2024-01-22T23:15:47.135288+00:00',
//           startDate: '2005-07-01T07:00:00+00:00',
//           updatedAt: null,
//         },
//         '34': {
//           id: 34,
//           name: '2006-07',
//           type: null,
//           stats: {
//             win: 80,
//             loss: 46,
//             push: 2,
//             unit: 20.95,
//             pending: 0,
//             canceled: 0,
//             noAction: 0,
//             uncharged: 128,
//           },
//           hidden: false,
//           endDate: '2007-07-01T06:59:59+00:00',
//           sportId: 2,
//           createdAt: '2024-01-22T23:15:47.135288+00:00',
//           startDate: '2006-07-01T07:00:00+00:00',
//           updatedAt: null,
//         },
//         '35': {
//           id: 35,
//           name: '2007-08',
//           type: null,
//           stats: {
//             win: 160,
//             loss: 121,
//             push: 7,
//             unit: 20.55,
//             pending: 0,
//             canceled: 0,
//             noAction: 0,
//             uncharged: 288,
//           },
//           hidden: false,
//           endDate: '2008-07-01T06:59:59+00:00',
//           sportId: 2,
//           createdAt: '2024-01-22T23:15:47.135288+00:00',
//           startDate: '2007-07-01T07:00:00+00:00',
//           updatedAt: null,
//         },
//         '36': {
//           id: 36,
//           name: '2008-09',
//           type: null,
//           stats: {
//             win: 272,
//             loss: 215,
//             push: 10,
//             unit: 40.85,
//             pending: 0,
//             canceled: 0,
//             noAction: 0,
//             uncharged: 497,
//           },
//           hidden: false,
//           endDate: '2009-07-01T06:59:59+00:00',
//           sportId: 2,
//           createdAt: '2024-01-22T23:15:47.135288+00:00',
//           startDate: '2008-07-01T07:00:00+00:00',
//           updatedAt: null,
//         },
//         '37': {
//           id: 37,
//           name: '2009-10',
//           type: null,
//           stats: {
//             win: 265,
//             loss: 188,
//             push: 7,
//             unit: 61.1,
//             pending: 0,
//             canceled: 0,
//             noAction: 0,
//             uncharged: 460,
//           },
//           hidden: false,
//           endDate: '2010-07-01T06:59:59+00:00',
//           sportId: 2,
//           createdAt: '2024-01-22T23:15:47.135288+00:00',
//           startDate: '2009-07-01T07:00:00+00:00',
//           updatedAt: null,
//         },
//         '38': {
//           id: 38,
//           name: '2010-11',
//           type: null,
//           stats: {
//             win: 232,
//             loss: 220,
//             push: 5,
//             unit: -8.6,
//             pending: 0,
//             canceled: 0,
//             noAction: 0,
//             uncharged: 457,
//           },
//           hidden: false,
//           endDate: '2011-07-01T06:59:59+00:00',
//           sportId: 2,
//           createdAt: '2024-01-22T23:15:47.135288+00:00',
//           startDate: '2010-07-01T07:00:00+00:00',
//           updatedAt: null,
//         },
//         '39': {
//           id: 39,
//           name: '2011-12',
//           type: null,
//           stats: {
//             win: 173,
//             loss: 133,
//             push: 6,
//             unit: 30.05,
//             pending: 0,
//             canceled: 0,
//             noAction: 0,
//             uncharged: 312,
//           },
//           hidden: false,
//           endDate: '2012-07-01T06:59:59+00:00',
//           sportId: 2,
//           createdAt: '2024-01-22T23:15:47.135288+00:00',
//           startDate: '2011-07-01T07:00:00+00:00',
//           updatedAt: null,
//         },
//         '40': {
//           id: 40,
//           name: '2012-13',
//           type: null,
//           stats: {
//             win: 101,
//             loss: 55,
//             push: 4,
//             unit: 43,
//             pending: 0,
//             canceled: 0,
//             noAction: 0,
//             uncharged: 160,
//           },
//           hidden: false,
//           endDate: '2013-07-01T06:59:59+00:00',
//           sportId: 2,
//           createdAt: '2024-01-22T23:15:47.135288+00:00',
//           startDate: '2012-07-01T07:00:00+00:00',
//           updatedAt: null,
//         },
//         '41': {
//           id: 41,
//           name: '2013-14',
//           type: null,
//           stats: {
//             win: 105,
//             loss: 87,
//             push: 5,
//             unit: 9.55,
//             pending: 0,
//             canceled: 0,
//             noAction: 0,
//             uncharged: 197,
//           },
//           hidden: false,
//           endDate: '2014-07-01T06:59:59+00:00',
//           sportId: 2,
//           createdAt: '2024-01-22T23:15:47.135288+00:00',
//           startDate: '2013-07-01T07:00:00+00:00',
//           updatedAt: null,
//         },
//         '42': {
//           id: 42,
//           name: '2014-15',
//           type: null,
//           stats: {
//             win: 189,
//             loss: 176,
//             push: 6,
//             unit: -2.85,
//             pending: 0,
//             canceled: 0,
//             noAction: 0,
//             uncharged: 371,
//           },
//           hidden: false,
//           endDate: '2015-07-01T06:59:59+00:00',
//           sportId: 2,
//           createdAt: '2024-01-22T23:15:47.135288+00:00',
//           startDate: '2014-07-01T07:00:00+00:00',
//           updatedAt: null,
//         },
//         '43': {
//           id: 43,
//           name: '2015-16',
//           type: null,
//           stats: {
//             win: 122,
//             loss: 98,
//             push: 6,
//             unit: 16,
//             pending: 0,
//             canceled: 0,
//             noAction: 0,
//             uncharged: 226,
//           },
//           hidden: false,
//           endDate: '2016-07-01T06:59:59+00:00',
//           sportId: 2,
//           createdAt: '2024-01-22T23:15:47.135288+00:00',
//           startDate: '2015-07-01T07:00:00+00:00',
//           updatedAt: null,
//         },
//         '44': {
//           id: 44,
//           name: '2016-17',
//           type: null,
//           stats: {
//             win: 287,
//             loss: 241,
//             push: 15,
//             unit: 18.6,
//             pending: 0,
//             canceled: 0,
//             noAction: 0,
//             uncharged: 543,
//           },
//           hidden: false,
//           endDate: '2017-07-01T06:59:59+00:00',
//           sportId: 2,
//           createdAt: '2024-01-22T23:15:47.135288+00:00',
//           startDate: '2016-07-01T07:00:00+00:00',
//           updatedAt: null,
//         },
//         '45': {
//           id: 45,
//           name: '2017-18',
//           type: null,
//           stats: {
//             win: 138,
//             loss: 89,
//             push: 3,
//             unit: 39.45,
//             pending: 0,
//             canceled: 0,
//             noAction: 0,
//             uncharged: 230,
//           },
//           hidden: false,
//           endDate: '2018-07-01T06:59:59+00:00',
//           sportId: 2,
//           createdAt: '2024-01-22T23:15:47.135288+00:00',
//           startDate: '2017-07-01T07:00:00+00:00',
//           updatedAt: null,
//         },
//         '46': {
//           id: 46,
//           name: '2018-19',
//           type: null,
//           stats: {
//             win: 88,
//             loss: 63,
//             push: 2,
//             unit: 18.5,
//             pending: 0,
//             canceled: 0,
//             noAction: 0,
//             uncharged: 153,
//           },
//           hidden: false,
//           endDate: '2019-07-01T06:59:59+00:00',
//           sportId: 2,
//           createdAt: '2024-01-22T23:15:47.135288+00:00',
//           startDate: '2018-07-01T07:00:00+00:00',
//           updatedAt: null,
//         },
//         '47': {
//           id: 47,
//           name: '2019-20',
//           type: null,
//           stats: {
//             win: 35,
//             loss: 39,
//             push: 0,
//             unit: -8.15,
//             pending: 0,
//             canceled: 0,
//             noAction: 0,
//             uncharged: 74,
//           },
//           hidden: false,
//           endDate: '2020-07-01T06:59:59+00:00',
//           sportId: 2,
//           createdAt: '2024-01-22T23:15:47.135288+00:00',
//           startDate: '2019-07-01T07:00:00+00:00',
//           updatedAt: null,
//         },
//         '48': {
//           id: 48,
//           name: '2020-21',
//           type: null,
//           stats: {
//             win: 72,
//             loss: 64,
//             push: 2,
//             unit: 0.35,
//             pending: 0,
//             canceled: 2,
//             noAction: 0,
//             uncharged: 140,
//           },
//           hidden: false,
//           endDate: '2021-07-01T06:59:59+00:00',
//           sportId: 2,
//           createdAt: '2024-01-22T23:15:47.135288+00:00',
//           startDate: '2020-07-01T07:00:00+00:00',
//           updatedAt: null,
//         },
//         '49': {
//           id: 49,
//           name: '2021-22',
//           type: null,
//           stats: {
//             win: 177,
//             loss: 127,
//             push: 2,
//             unit: 38.65,
//             pending: 0,
//             canceled: 3,
//             noAction: 0,
//             uncharged: 296,
//           },
//           hidden: false,
//           endDate: '2022-07-01T06:59:59+00:00',
//           sportId: 2,
//           createdAt: '2024-01-22T23:15:47.135288+00:00',
//           startDate: '2021-07-01T07:00:00+00:00',
//           updatedAt: null,
//         },
//         '50': {
//           id: 50,
//           name: '2022-23',
//           type: null,
//           stats: {
//             win: 247,
//             loss: 214,
//             push: 7,
//             unit: 11,
//             pending: 0,
//             canceled: 0,
//             noAction: 0,
//             uncharged: 193,
//           },
//           hidden: false,
//           endDate: '2023-07-01T06:59:59+00:00',
//           sportId: 2,
//           createdAt: '2024-01-22T23:15:47.135288+00:00',
//           startDate: '2022-07-01T07:00:00+00:00',
//           updatedAt: null,
//         },
//         '51': {
//           id: 51,
//           name: '2023-24',
//           type: null,
//           stats: {
//             win: 234,
//             loss: 238,
//             push: 12,
//             unit: -27.45,
//             pending: 0,
//             canceled: 0,
//             noAction: 0,
//             uncharged: 35,
//           },
//           hidden: false,
//           endDate: '2024-07-01T06:59:59+00:00',
//           sportId: 2,
//           createdAt: '2024-01-22T23:15:47.135288+00:00',
//           startDate: '2023-07-01T07:00:00+00:00',
//           updatedAt: null,
//         },
//         '65': {
//           id: 65,
//           name: '1999-00',
//           type: null,
//           stats: {
//             win: 68,
//             loss: 62,
//             push: 2,
//             unit: 5.5,
//             pending: 0,
//             canceled: 0,
//             noAction: 0,
//             uncharged: 132,
//           },
//           hidden: false,
//           endDate: '2000-07-01T06:59:59+00:00',
//           sportId: 2,
//           createdAt: '2024-09-03T19:18:27.977417+00:00',
//           startDate: '1999-07-01T07:00:00+00:00',
//           updatedAt: null,
//         },
//       },
//       sportMeta: { id: 2, name: 'College basketball', active: false, shortName: 'CBB' },
//     },
//     '3': {
//       cumulative: {
//         win: 242,
//         loss: 173,
//         pending: 5,
//         push: 7,
//         canceled: 3,
//         noAction: 0,
//         risk: 430.03,
//         units: 52.12,
//         total: 430,
//       },
//       seasons: {
//         '52': {
//           win: 14,
//           loss: 7,
//           pending: 0,
//           push: 0,
//           canceled: 0,
//           noAction: 0,
//           risk: 42,
//           units: 12.1,
//           total: 42,
//         },
//         '53': {
//           win: 32,
//           loss: 26,
//           pending: 0,
//           push: 2,
//           canceled: 0,
//           noAction: 0,
//           risk: 180,
//           units: 10.649999999999999,
//           total: 180,
//         },
//         '54': {
//           win: 28,
//           loss: 19,
//           pending: 0,
//           push: 0,
//           canceled: 0,
//           noAction: 0,
//           risk: 94,
//           units: 13.8,
//           total: 94,
//         },
//         '55': {
//           win: 20,
//           loss: 10,
//           pending: 0,
//           push: 1,
//           canceled: 2,
//           noAction: 0,
//           risk: 132,
//           units: 35.8,
//           total: 132,
//         },
//         '56': {
//           win: 30,
//           loss: 24,
//           pending: 0,
//           push: 0,
//           canceled: 0,
//           noAction: 0,
//           risk: 110,
//           units: 9,
//           total: 108,
//         },
//         '57': {
//           win: 30,
//           loss: 24,
//           pending: 0,
//           push: 1,
//           canceled: 0,
//           noAction: 0,
//           risk: 165,
//           units: 10.350000000000001,
//           total: 165,
//         },
//         '58': {
//           win: 72,
//           loss: 50,
//           pending: 1,
//           push: 3,
//           canceled: 1,
//           noAction: 0,
//           risk: 630.15,
//           units: 85.35,
//           total: 635,
//         },
//         '63': {
//           win: 16,
//           loss: 13,
//           pending: 4,
//           push: 0,
//           canceled: 0,
//           noAction: 0,
//           risk: 99,
//           units: 4.949999999999999,
//           total: 99,
//         },
//       },
//       firstSeasonId: 52,
//       lastSeasonId: 63,
//       firstSeasonDate: 1498892400000,
//       lastSeasonDate: 1719817200000,
//       last4Ids: [56, 57, 58, 63],
//       last4: [
//         {
//           win: 30,
//           loss: 24,
//           pending: 0,
//           push: 0,
//           canceled: 0,
//           noAction: 0,
//           risk: 55,
//           units: 4.5,
//           total: 54,
//         },
//         {
//           win: 30,
//           loss: 24,
//           pending: 0,
//           push: 1,
//           canceled: 0,
//           noAction: 0,
//           risk: 55,
//           units: 3.4499999999999993,
//           total: 55,
//         },
//         {
//           win: 72,
//           loss: 50,
//           pending: 1,
//           push: 3,
//           canceled: 1,
//           noAction: 0,
//           risk: 126.03,
//           units: 17.07,
//           total: 127,
//         },
//         {
//           win: 16,
//           loss: 13,
//           pending: 4,
//           push: 0,
//           canceled: 0,
//           noAction: 0,
//           risk: 33,
//           units: 1.6500000000000004,
//           total: 33,
//         },
//       ],
//       seasonsMeta: {
//         '52': {
//           id: 52,
//           name: '2017',
//           type: null,
//           stats: {
//             win: 14,
//             loss: 7,
//             push: 0,
//             unit: 6.05,
//             pending: 0,
//             canceled: 0,
//             noAction: 0,
//             uncharged: 21,
//           },
//           hidden: false,
//           endDate: '2018-07-01T06:59:59+00:00',
//           sportId: 3,
//           createdAt: '2024-01-22T23:15:47.135288+00:00',
//           startDate: '2017-07-01T07:00:00+00:00',
//           updatedAt: null,
//         },
//         '53': {
//           id: 53,
//           name: '2018',
//           type: null,
//           stats: {
//             win: 32,
//             loss: 26,
//             push: 2,
//             unit: 3.55,
//             pending: 0,
//             canceled: 0,
//             noAction: 0,
//             uncharged: 60,
//           },
//           hidden: false,
//           endDate: '2019-07-01T06:59:59+00:00',
//           sportId: 3,
//           createdAt: '2024-01-22T23:15:47.135288+00:00',
//           startDate: '2018-07-01T07:00:00+00:00',
//           updatedAt: null,
//         },
//         '54': {
//           id: 54,
//           name: '2019',
//           type: null,
//           stats: {
//             win: 28,
//             loss: 19,
//             push: 0,
//             unit: 6.9,
//             pending: 0,
//             canceled: 0,
//             noAction: 0,
//             uncharged: 47,
//           },
//           hidden: false,
//           endDate: '2020-07-01T06:59:59+00:00',
//           sportId: 3,
//           createdAt: '2024-01-22T23:15:47.135288+00:00',
//           startDate: '2019-07-01T07:00:00+00:00',
//           updatedAt: null,
//         },
//         '55': {
//           id: 55,
//           name: '2020',
//           type: null,
//           stats: {
//             win: 20,
//             loss: 10,
//             push: 1,
//             unit: 8.95,
//             pending: 0,
//             canceled: 2,
//             noAction: 0,
//             uncharged: 33,
//           },
//           hidden: false,
//           endDate: '2021-07-01T06:59:59+00:00',
//           sportId: 3,
//           createdAt: '2024-01-22T23:15:47.135288+00:00',
//           startDate: '2020-07-01T07:00:00+00:00',
//           updatedAt: null,
//         },
//         '56': {
//           id: 56,
//           name: '2021',
//           type: null,
//           stats: {
//             win: 30,
//             loss: 24,
//             push: 0,
//             unit: 4.5,
//             pending: 0,
//             canceled: 0,
//             noAction: 0,
//             uncharged: 54,
//           },
//           hidden: false,
//           endDate: '2022-07-01T06:59:59+00:00',
//           sportId: 3,
//           createdAt: '2024-01-22T23:15:47.135288+00:00',
//           startDate: '2021-07-01T07:00:00+00:00',
//           updatedAt: null,
//         },
//         '57': {
//           id: 57,
//           name: '2022',
//           type: null,
//           stats: {
//             win: 46,
//             loss: 38,
//             push: 1,
//             unit: 2.6,
//             pending: 0,
//             canceled: 0,
//             noAction: 0,
//             uncharged: 37,
//           },
//           hidden: false,
//           endDate: '2023-07-01T06:59:59+00:00',
//           sportId: 3,
//           createdAt: '2024-01-22T23:15:47.135288+00:00',
//           startDate: '2022-07-01T07:00:00+00:00',
//           updatedAt: null,
//         },
//         '58': {
//           id: 58,
//           name: '2023',
//           type: null,
//           stats: {
//             win: 72,
//             loss: 50,
//             push: 3,
//             unit: 17.07,
//             pending: 7,
//             canceled: 1,
//             noAction: 0,
//             uncharged: 80,
//           },
//           hidden: false,
//           endDate: '2024-07-01T06:59:59+00:00',
//           sportId: 3,
//           createdAt: '2024-01-22T23:15:47.135288+00:00',
//           startDate: '2023-07-01T07:00:00+00:00',
//           updatedAt: null,
//         },
//         '63': {
//           id: 63,
//           name: '2024',
//           type: null,
//           stats: {
//             win: 15,
//             loss: 13,
//             push: 0,
//             unit: 0.65,
//             pending: -6,
//             canceled: 0,
//             noAction: 0,
//             uncharged: 32,
//           },
//           hidden: false,
//           endDate: '2025-02-10T06:59:00+00:00',
//           sportId: 3,
//           createdAt: '2024-08-02T15:39:09.359605+00:00',
//           startDate: '2024-07-01T07:00:00+00:00',
//           updatedAt: null,
//         },
//       },
//       sportMeta: { id: 3, name: 'NFL', active: true, shortName: 'NFL' },
//     },
//   },
//   sports: {
//     '1': [
//       [
//         [64],
//         {
//           win: 13,
//           loss: 6,
//           pending: 14,
//           push: 0,
//           canceled: 0,
//           noAction: 0,
//           risk: 33,
//           units: 6.4,
//           total: 33,
//         },
//         'Current season',
//       ],
//       [
//         [25, 26, 27],
//         {
//           win: 161,
//           loss: 100,
//           pending: 0,
//           push: 6,
//           canceled: 1,
//           noAction: 0,
//           risk: 268,
//           units: 50.8,
//           total: 268,
//         },
//         'Last 3 seasons',
//       ],
//     ],
//     '2': [
//       [
//         [51],
//         {
//           win: 302,
//           loss: 300,
//           pending: 0,
//           push: 14,
//           canceled: 0,
//           noAction: 0,
//           risk: 649.5,
//           units: -21.94999999999999,
//           total: 616,
//         },
//         'Current season',
//       ],
//       [
//         [65, 49, 50],
//         {
//           win: 424,
//           loss: 341,
//           pending: 0,
//           push: 9,
//           canceled: 3,
//           noAction: 0,
//           risk: 780.5,
//           units: 49.650000000000006,
//           total: 777,
//         },
//         'Last 3 seasons',
//       ],
//     ],
//     '3': [
//       [
//         [63],
//         {
//           win: 16,
//           loss: 13,
//           pending: 4,
//           push: 0,
//           canceled: 0,
//           noAction: 0,
//           risk: 33,
//           units: 1.6500000000000004,
//           total: 33,
//         },
//         'Current season',
//       ],
//       [
//         [56, 57, 58],
//         {
//           win: 132,
//           loss: 98,
//           pending: 1,
//           push: 4,
//           canceled: 1,
//           noAction: 0,
//           risk: 236.03,
//           units: 25.02,
//           total: 236,
//         },
//         'Last 3 seasons',
//       ],
//     ],
//   },
// };

// const formatNumber = (value: number, options?: Intl.NumberFormatOptions) =>
//   new Intl.NumberFormat('en-US', {
//     style: 'decimal',
//     minimumFractionDigits: 2,
//     maximumFractionDigits: 2,
//     ...options,
//   }).format(value);

export default function Hero() {
  // const data = useDataVike();

  return (
    <div className="relative isolate overflow-hidden">
      {/* eslint-disable-next-line tailwindcss/no-custom-classname */}
      <div
        className="bg-repeat"
        style={{ backgroundImage: `url("${encodeURI(decodeURIComponent(srcHeroPattern))}")` }}
      >
        <div className="border-zinc-600/80 border-b bg-linear-to-bl from-emerald-400/50 to-70% px-4 lg:px-16">
          <div className="mx-auto max-w-6xl pt-32 pb-12 sm:py-24">
            <div className="mt-6 flex flex-col justify-center gap-x-8 gap-y-20 lg:flex-row lg:px-8 xl:px-16">
              <div className="my-auto text-left">
                <h1 className="mx-auto max-w-[310px] text-center font-bold text-5xl text-white tracking-normal sm:leading-none sm:tracking-tight lg:pe-4 lg:text-left min-[470px]:max-w-2xl min-[470px]:text-7xl">
                  Pro betting meets pick selling
                </h1>
                <section className="mx-auto my-auto mt-10 max-w-prose text-center text-base text-white/70 leading-6 sm:max-w-2xl sm:text-base lg:text-left ">
                  <div className="mx-auto max-w-xl lg:mx-0">
                    RAS is a team of professional bettors &mdash; trusted by sharps, respected by
                    the market. Our NFL sides & totals have hit 58.78% all-time, beating the closing
                    line 83% of the time. Every result is independently verified at{' '}
                    <a
                      href="https://betstamp.app/u/RAS"
                      target="_blank"
                      className="text-white/70 underline"
                      rel="noreferrer"
                    >
                      betstamp
                    </a>
                    .
                  </div>
                </section>
                <div className="mt-10 flex flex-col items-center justify-center gap-y-4 sm:flex-row sm:flex-wrap sm:gap-x-6 sm:gap-y-4 lg:justify-start">
                  <a
                    className="inline-flex w-full justify-center space-x-0.5 overflow-hidden whitespace-nowrap rounded-sm bg-emerald-400/10 px-6 py-3 font-medium text-base text-emerald-400 ring-1 ring-emerald-400 ring-inset delay-150 ease-in-out hover:bg-emerald-400/10 hover:text-emerald-300 hover:ring-emerald-300 sm:w-auto lg:text-sm"
                    href="/order/nfl"
                  >
                    Explore services
                  </a>
                  <a
                    className="inline-flex w-full items-center justify-center space-x-1 overflow-hidden whitespace-nowrap rounded-sm px-6 py-3 font-medium text-base text-zinc-200 ring-1 ring-white/10 ring-inset transition hover:bg-white/5 hover:text-white sm:w-auto lg:text-sm"
                    href="/register"
                  >
                    <span>Sign up and get free picks</span>
                  </a>
                  <a
                    className="inline-flex w-full items-center justify-center space-x-1 overflow-hidden whitespace-nowrap py-3 font-normal text-sm text-zinc-200 transition hover:text-white sm:w-auto"
                    href="/about"
                  >
                    <span>Learn about RAS</span>
                    <ArrowRightIcon height={16} className="h-4 w-4" />
                  </a>
                </div>
              </div>
              <div className="mx-auto flex w-full flex-col rounded-sm bg-linear-to-b from-zinc-950/30 to-zinc-950/50 p-6 ring-1 ring-white/20 sm:w-full lg:flex lg:w-96 lg:flex-auto lg:justify-end">
                <div className="font-semibold text-base text-emerald-500">NFL sides & totals</div>
                <span className="my-3 text-xs text-zinc-200">
                  Results third party verified by{' '}
                  <a
                    href="https://betstamp.app/u/RAS"
                    target="_blank"
                    className="text-white/70 underline"
                    rel="noreferrer"
                  >
                    betstamp
                  </a>
                  .
                </span>
                <Table>
                  <TableHeader className="hidden md:contents">
                    <TableRow>
                      <TableHead className="w-1/4 whitespace-nowrap bg-transparent py-3.5 pl-4 text-left font-semibold text-sm text-white sm:pr-3 sm:pl-0 dark:bg-transparent">
                        Season
                      </TableHead>
                      <TableHead className="w-1/4 whitespace-nowrap bg-transparent py-3.5 pl-4 text-left font-semibold text-sm text-white sm:pr-3 sm:pl-0 dark:bg-transparent">
                        Record
                      </TableHead>
                      <TableHead className="w-1/4 whitespace-nowrap bg-transparent py-3.5 pl-4 text-left font-semibold text-sm text-white sm:pr-3 sm:pl-0 dark:bg-transparent">
                        Units
                      </TableHead>
                      <TableHead className="w-1/4 whitespace-nowrap bg-transparent py-3.5 pl-4 text-left font-semibold text-sm text-white sm:pr-3 sm:pl-0 dark:bg-transparent">
                        Win rate
                      </TableHead>
                    </TableRow>
                  </TableHeader>
                  <TableBody>
                    {nflBreakdowns.map((row) => (
                      <TableRow
                        key={row.season}
                        className="font-normal hover:group-[&]/tbody:bg-initial"
                      >
                        <TableCell className="w-1/4 whitespace-nowrap py-2 pl-0 font-semibold text-sm text-zinc-200 first-letter:uppercase sm:pr-3">
                          <span className="inline-block first-letter:uppercase">
                            {`${row.season || '-'}`.replace(/-+/g, ' ')}
                          </span>
                        </TableCell>
                        <TableCell className="w-1/4 whitespace-nowrap py-2 pl-0 text-sm text-zinc-200 sm:pr-3">
                          {row.win}-{row.loss}-{row.push}
                        </TableCell>
                        <TableCell
                          className={clsx(
                            'w-1/4 whitespace-nowrap py-2 pl-0 text-sm text-zinc-200 sm:pr-3',
                            row.units >= 0 ? 'text-emerald-500' : 'text-red-400',
                          )}
                        >
                          {row.units >= 0 ? '+' : ''}
                          {toFixed(row.units)}
                        </TableCell>
                        <TableCell className="w-1/4 whitespace-nowrap py-2 pl-0 text-sm text-zinc-200 sm:pr-3">
                          {toFixed((row.win / (row.win + row.loss)) * 100)}%
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                  <TableRow>
                    <TableCell colSpan={4} className="pl-0">
                      <hr className="my-2 border-white/20 border-t" />
                    </TableCell>
                  </TableRow>
                  <TableBody>
                    {nflSeasons.map((row) => (
                      <TableRow
                        key={row.season}
                        className="font-normal hover:group-[&]/tbody:bg-initial"
                      >
                        <TableCell className="w-1/4 whitespace-nowrap py-2 pl-0 font-semibold text-sm text-zinc-200 first-letter:uppercase sm:pr-3">
                          <span className="inline-block first-letter:uppercase">
                            {`${row.season || '-'}`.replace(/-+/g, ' ')}
                          </span>
                        </TableCell>
                        <TableCell className="w-1/4 whitespace-nowrap py-2 pl-0 text-sm text-zinc-200 sm:pr-3">
                          {row.win}-{row.loss}-{row.push}
                        </TableCell>
                        <TableCell
                          className={clsx(
                            'w-1/4 whitespace-nowrap py-2 pl-0 text-sm text-zinc-200 sm:pr-3',
                            row.units >= 0 ? 'text-emerald-500' : 'text-red-400',
                          )}
                        >
                          {row.units >= 0 ? '+' : ''}
                          {toFixed(row.units)}
                        </TableCell>
                        <TableCell className="w-1/4 whitespace-nowrap py-2 pl-0 text-sm text-zinc-200 sm:pr-3">
                          {toFixed((row.win / (row.win + row.loss)) * 100)}%
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </div>
              {/* <div className="font-semibold text-base text-emerald-500">All-time records</div>
                {[3, 2, 1].map((sportId) => {
                  const sportMeta = (data?.stats?.[sportId] || backupStats.stats[sportId])
                    ?.sportMeta;

                  return (
                    <div key={sportId} className="mt-4 flex flex-col">
                      <span className="mb-2 p-2 font-semibold text-base">{sportMeta?.name}</span>
                      <dl className="grid w-auto grid-flow-row grid-cols-1 gap-0 space-y-4 lg:grid-cols-1 sm:grid-cols-2 sm:grid-cols-auto lg:gap-0 sm:gap-8 lg:space-y-4 sm:space-y-0">
                        {(data?.sports?.[sportId] || backupStats.sports[sportId]).map(
                          ([seasonIds, nums, title]) => {
                            const firstSeasonMeta =
                              data?.stats?.[sportId]?.seasonsMeta[seasonIds[0]];
                            const lastSeasonMeta =
                              data?.stats?.[sportId]?.seasonsMeta[seasonIds[seasonIds.length - 1]];
                            const lastSeasonNameParts =
                              `${lastSeasonMeta?.name || firstSeasonMeta?.name || ''}`.split('-');
                            const lastSeasonName = lastSeasonNameParts[1] || lastSeasonNameParts[0];
                            const [firstSeasonName] =
                              `${firstSeasonMeta?.name || lastSeasonMeta?.name || ''}`.split('-');
                            const sportShortName =
                              sportMeta?.shortName.toLowerCase() || sportMeta?.name.toLowerCase();
                            const seasonPath =
                              firstSeasonName === lastSeasonName ? '' : '/season/all-time';

                            return (
                              <a
                                href={`/archive/${sportShortName}${seasonPath}`}
                                key={`${sportId}-${seasonIds}-${title}`}
                                className="group flex cursor-pointer flex-col rounded-sm bg-white/5 p-4 ring-1 ring-white/20 hover:bg-white/10 hover:shadow-inner"
                              >
                                <dt className="flex flex-row items-start justify-between space-x-1 font-semibold text-sm text-zinc-200">
                                  <span>
                                    {(firstSeasonName === lastSeasonName
                                      ? firstSeasonName
                                      : `${firstSeasonName}-${lastSeasonName}`) || ''}{' '}
                                    {title}
                                  </span>
                                  <ChevronRightIcon
                                    height={20}
                                    className="size-5 shrink-0 group-hover:hidden"
                                  />
                                  <ArrowRightIcon
                                    height={20}
                                    className="hidden size-5 shrink-0 group-hover:inline-block"
                                  />
                                </dt>
                                <dd className="mt-2 font-semibold text-white text-xl tracking-tight">
                                  {nums?.win || 0}-{nums?.loss || 0}-{nums?.push || 0}{' '}
                                  <span className="text-sm text-zinc-400">
                                    (
                                    {formatNumber(
                                      (nums?.win || 0) / ((nums?.win || 0) + (nums?.loss || 0)) ||
                                        0,
                                      { style: 'percent' },
                                    )}
                                    )
                                  </span>
                                </dd>
                                <dd className="mt-1 w-fit rounded-sm bg-emerald-400/30 px-2.5 py-0.5 font-semibold text-white text-xs lg:mx-0">
                                  <span>
                                    {nums?.units < 0 ? '' : '+'}
                                    {formatNumber(nums?.units || 0)} units
                                  </span>
                                </dd>
                              </a>
                            );
                          },
                        )}
                      </dl>
                    </div>
                  );
                })}
              </div> */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
